import { Component, OnInit } from '@angular/core';
import { UsuarioLogadoGQL } from '../generated/graphql';
import { AuthService } from '../services/auth/auth.service';
import { PubSubService } from '../services/util/pub-sub.service';
import { AppComponent } from '../app.component';
import { MenuService } from './layout/menu/app.menu.service';
import { Subject, finalize } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { AppBreadcrumbComponent } from './layout/breadcrumb/app.breadcrumb.component';
import { AppMenuComponent } from './layout/menu/app.menu.component';
import { AppTopBarComponent } from './layout/topbar/app.topbar.component';
import { NgClass } from '@angular/common';
import { AppProfileComponent } from './layout/profile/app.profile.component';
import { AppConfigComponent } from '../app.config.component';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss'],
    standalone: true,
    imports: [
    NgClass,
    AppTopBarComponent,
    AppMenuComponent,
    AppBreadcrumbComponent,
    RouterOutlet,
    AppProfileComponent,
    AppConfigComponent
],
})
export class AppMainComponent implements OnInit {
  loading: boolean = true;

  topbarMenuActive: boolean = false;

  overlayMenuActive: boolean = false;

  staticMenuDesktopInactive: boolean = false;
  staticMenuDesktopInactiveSubject: Subject<boolean> = new Subject<boolean>();

  staticMenuMobileActive: boolean = false;
  staticMenuMobileActiveSubject: Subject<boolean> = new Subject<boolean>();

  menuClick: boolean = false;

  topbarItemClick: boolean = false;

  activeTopbarItem: any;

  menuHoverActive: boolean = false;

  rightPanelActive: boolean = false;

  rightPanelClick: boolean = false;

  megaMenuActive: boolean = false;

  megaMenuClick: boolean = false;

  usermenuActive: boolean = false;

  usermenuClick: boolean = false;

  activeProfileItem: any;

  configActive: boolean = false;

  configClick: boolean = false;

  constructor(
    private usuarioLogado: UsuarioLogadoGQL,
    private authService: AuthService,
    private pubSubService: PubSubService,
    private menuService: MenuService,
    public app: AppComponent
  ) {}

  ngOnInit() {
    this.buscarUsuarioLogado();
  }

  onLayoutClick() {
    if (!this.topbarItemClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    if (!this.rightPanelClick) {
      this.rightPanelActive = false;
    }

    if (!this.megaMenuClick) {
      this.megaMenuActive = false;
    }

    if (!this.usermenuClick && this.isSlim()) {
      this.usermenuActive = false;
      this.activeProfileItem = null;
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isSlim()) {
        this.menuService.reset();
      }

      if (this.overlayMenuActive || this.staticMenuMobileActive) {
        this.hideOverlayMenu();
      }

      this.menuHoverActive = false;
    }

    if (this.configActive && !this.configClick) {
      this.configActive = false;
    }

    this.configClick = false;
    this.topbarItemClick = false;
    this.menuClick = false;
    this.rightPanelClick = false;
    this.megaMenuClick = false;
    this.usermenuClick = false;
  }

  onMenuButtonClick(event: { preventDefault: () => void; }) {
    this.menuClick = true;
    this.topbarMenuActive = false;

    if (this.app.layoutMode === 'overlay') {
      this.overlayMenuActive = !this.overlayMenuActive;
    } else {
      if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        this.staticMenuDesktopInactiveSubject.next(this.staticMenuDesktopInactive);
      } else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
        this.staticMenuMobileActiveSubject.next(this.staticMenuMobileActive);
      }
    }

    event.preventDefault();
  }

  onMenuClick($event: any) {
    this.menuClick = true;
  }

  onTopbarMenuButtonClick(event: { preventDefault: () => void; }) {
    this.topbarItemClick = true;
    this.topbarMenuActive = !this.topbarMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onTopbarItemClick(event: { preventDefault: () => void; }, item: any) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  onTopbarSubItemClick(event: { preventDefault: () => void; }) {
    event.preventDefault();
  }

  onRightPanelButtonClick(event: { preventDefault: () => void; }) {
    this.rightPanelClick = true;
    this.rightPanelActive = !this.rightPanelActive;
    event.preventDefault();
  }

  onRightPanelClick() {
    this.rightPanelClick = true;
  }

  onMegaMenuButtonClick(event: { preventDefault: () => void; }) {
    this.megaMenuClick = true;
    this.megaMenuActive = !this.megaMenuActive;
    event.preventDefault();
  }

  onMegaMenuClick() {
    this.megaMenuClick = true;
  }

  hideOverlayMenu() {
    this.overlayMenuActive = false;
    this.staticMenuMobileActive = false;
  }

  onRippleChange(event: { checked: boolean; }) {
    this.app.ripple = event.checked;
  }

  onConfigClick(event: any) {
    this.configClick = true;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  isMobile() {
    return window.innerWidth <= 640;
  }

  isHorizontal() {
    return this.app.layoutMode === 'horizontal';
  }

  isSlim() {
    return this.app.layoutMode === 'slim';
  }

  isOverlay() {
    return this.app.layoutMode === 'overlay';
  }

  buscarUsuarioLogado() {
    this.usuarioLogado.fetch().pipe(
      finalize(() => {
        this.pubSubService.addEvent('ATUALIZAR_USUARIO_LOGADO');
        this.loading = false;
      })
    ).subscribe({
      next: (rs) => {
        let usuario = rs.data.usuarioLogado;

        if (usuario) {
          this.authService.saveUser({
            nanoid: usuario.nanoid,
            nome: usuario.nome ?? '',
            foto: usuario.foto ?? '',
            permissoes: usuario.permissoes?.map((el) => el.nanoid) ?? [],
            permissoesGrupo: usuario.grupo_sistema?.permissoes?.map((el) => el.nanoid) ?? [],
          });
        }
      },
    });
  }
}
